'use client'
import React from 'react'
import { HoverBorderGradient } from '../ui/hover-border-gradient'

export function HoverBorderGradientDemo({ children, disabled, ...props }) {
  return (
    <div className='w-full flex justify-center text-center'>
      <HoverBorderGradient
        disabled={disabled}
        // containerClassName='rounded-full w-full'
        containerClassName={`rounded-full w-full ${
          disabled ? 'opacity-50 cursor-not-allowed' : ''
        }`}
        as='button'
        className='w-full justify-center dark:bg-black bg-[#2446f9] text-white dark:text-white flex items-center space-x-2'
        {...props}
      >
        <span>{children}</span>
      </HoverBorderGradient>
    </div>
  )
}
